const menuToTrigger = new WeakMap<HTMLElement, HTMLElement>();

export const registerMenu = (menuEl: HTMLElement, triggerEl: HTMLElement | null) => {
  if (!menuEl) return;
  if (triggerEl) menuToTrigger.set(menuEl, triggerEl);
};

export const unregisterMenu = (menuEl: HTMLElement | null) => {
  if (!menuEl) return;
  menuToTrigger.delete(menuEl);
};

export const getTriggerForMenu = (menuEl: HTMLElement | null) => {
  if (!menuEl) return null;
  return menuToTrigger.get(menuEl) || null;
};

export default {};
